module.exports = __webpack_public_path__ + "static/facebook-e2ca97ae3223b04ebd050f46a1ad3854.jpg";